import checkBalance from './check-balance'
import profile from './profile'
import addCard from './add-card'
import support from './support'

export default (Bus) => {
  checkBalance(Bus)
  profile(Bus)
  addCard(Bus)
  support(Bus)
}
